import React, { Component } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { hideModal } from "../../../../usecases/commons/hide-modal";
import { translate as t } from "../../../../infrastructure/translate/localization";

import InsuranceTab from "../../benefitsTabs/InsuranceTab";
import CircleButton from "../../commons/CircleButton";
import iFeelImg from "../../../../assets/img/ifeel-benefit.png";
import "./healthInsuranceModal.scss";

class IFeelModal extends Component {
  constructor(props) {
    super(props);
    this.toggleTab = this.toggleTab.bind(this);
    this.state = {
      activeTab: "",
      selectedTab: null,
      config: null,
    };
  }

  componentDidMount() {
    const { insuranceProducts, insuranceConfig } = this.props;
    const { activeTab } = this.state;
    if (activeTab === "") {
      this.setState({
        activeTab: insuranceProducts[0].modalityId,
        selectedTab: insuranceProducts[0],
        config: insuranceConfig,
      });
    }
  }

  handleAccept = () => {
    hideModal();
  };

  findInsurance = () => {
    const { activeTab, config } = this.state;
    return config?.find((insurance) => insurance.modalityId === activeTab);
  };

  toggleTab({ tabId, selected }) {
    const { activeTab } = this.state;
    if (activeTab !== tabId) {
      this.setState({
        activeTab: tabId,
        selectedTab: selected,
      });
    }
  }

  render() {
    const { insuranceProducts } = this.props;
    const { activeTab, selectedTab } = this.state;
    const item = this.findInsurance();

    return (
      <div className="modal-container">
        <CircleButton
          className="primary close-modal"
          icon="times"
          handlerClick={() => hideModal()}
        />
        <div className="health-benefits">
          <div className="modal-title">
            <div>
              <p className="title">
                {t("benefits-section.ifeel-benefit.ifeel")}
              </p>
              <p className="description">
                {t("benefits-section.ifeel-benefit.ifeel-description")}
              </p>
            </div>
            <div className="header-image">
              <img src={iFeelImg} alt="iFeel" />
            </div>
          </div>

          <div className="select-insurance-product">
            {insuranceProducts.map((prod) => {
              return (
                <InsuranceTab
                  key={prod.modalityId}
                  activeTab={activeTab === prod.modalityId}
                  name={`${prod.insuranceCompany}: ${prod.modalityName}`}
                  handlerClick={() =>
                    this.toggleTab({ tabId: prod.modalityId, selected: prod })
                  }
                />
              );
            })}
          </div>

          <table className="insurance-benefits-advances">
            <tbody>
              <th colSpan={2}>
                {t("benefits-section.health-insurance-benefit.insurance-type")}
              </th>
              <th>{t("common-messages.subsidy")}</th>
              {selectedTab && (
                <tr>
                  <td className="check">
                    <div className="checkbox-select">
                      <FontAwesomeIcon icon="check" />
                    </div>
                  </td>
                  <td>
                    <p>{t("common-messages.employee")}</p>
                  </td>
                  <td>
                    <input
                      name="employee"
                      type="number"
                      placeholder="0%"
                      maxLength={3}
                      min="1"
                      max="100"
                      pattern="([0-1]?[0-9]{2})"
                      value={
                        item.subvention.employee
                          ? item.subvention.employee * 100
                          : ""
                      }
                    />
                    <span>%</span>
                  </td>
                </tr>
              )}

              {selectedTab && (
                <tr>
                  <td className="check">
                    <div className="checkbox-select">
                      <FontAwesomeIcon icon="check" />
                    </div>
                  </td>
                  <td>
                    <p>{t("common-messages.spouse")}</p>
                  </td>
                  <td>
                    <input
                      name="partner"
                      type="number"
                      placeholder="0%"
                      maxLength={3}
                      min="1"
                      max="100"
                      pattern="([0-1]?[0-9]{2})"
                      value={
                        item.subvention.partner
                          ? item.subvention.partner * 100
                          : ""
                      }
                    />
                    <span>%</span>
                  </td>
                </tr>
              )}
              {selectedTab && (
                <tr>
                  <td className="check">
                    <div className="checkbox-select">
                      <FontAwesomeIcon icon="check" />
                    </div>
                  </td>
                  <td>
                    <p>{t("common-messages.decendents")}</p>
                  </td>
                  <td>
                    <input
                      name="descendant"
                      type="number"
                      placeholder="0%"
                      maxLength={3}
                      min="1"
                      max="100"
                      pattern="([0-1]?[0-9]{2})"
                      value={
                        item.subvention.descendant
                          ? item.subvention.descendant * 100
                          : ""
                      }
                    />
                    <span>%</span>
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          <div className="center-content">
            <button
              type="button"
              className="btn-line primary"
              onClick={this.handleAccept}
            >
              {t("actions.save")}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

IFeelModal.propTypes = {
  insuranceProducts: PropTypes.array.isRequired,
  insuranceConfig: PropTypes.array.isRequired,
};

export default IFeelModal;
